<template>
  <modal
    ref="modal"
    centered
    scrollable
    name="set-avatar"
    ok-title="Uložiť"
    cancel-title="Zrušiť"
    title="Nastaviť profilový obrázok"
    @hidden="Object.assign($data, $options.data())"
    @ok="uploadImage"
  >
    <div v-bar>
      <div>
        <input
          ref="file"
          accept="image/*"
          type="file"
          @change="loadImage($event)"
        />
        <div v-if="$store.state.user.current.avatar" class="my-2">
          <b-btn variant="danger" @click="removeImage"> Odstrániť </b-btn>
        </div>
        <cropper
          ref="cropper"
          :class="{ cropper: image }"
          :src="image"
          :stencil-props="{
            aspectRatio: 1 / 1,
          }"
          stencil-component="circle-stencil"
        />
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  components: {
    Modal,
    Cropper,
  },
  data() {
    return {
      image: '',
    }
  },
  methods: {
    loadImage(event) {
      const input = event.target
      if (input.files && input.files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.image = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    uploadImage() {
      const { canvas } = this.$refs.cropper.getResult()
      if (canvas) {
        const form = new FormData()
        canvas.toBlob((blob) => {
          form.append('image', blob, 'avatar')
          this.$api
            .post(
              'users/' + this.$store.state.user.current.id + '/set_avatar',
              form,
            )
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.success,
                timer: 5000,
              })
              this.$emit('saved')
              this.close()
            })
        }, 'image/jpeg')
      }
    },
    removeImage() {
      this.$api
        .post('users/' + this.$store.state.user.current.id + '/remove_avatar')
        .then((res) => {
          this.$swal({
            type: 'success',
            position: 'top',
            showCloseButton: true,
            text: res.data.success,
            timer: 5000,
          })
          this.$emit('saved')
          this.close()
        })
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>
<style>
.cropper {
  margin-top: 0.5rem;
  height: 300px;
}
.vue-advanced-cropper__background,
.vue-advanced-cropper__foreground {
  background: #fff;
}
</style>
